export default __webpack_public_path__ + "static/media/imageColorization1Low.3bcb9972.png";